module.exports = __webpack_public_path__ + "static/media/gameRideMechanic.90ecd908.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameRideMechanic.png
// module id = 2636
// module chunks = 0